import { SubmissionError } from 'redux-form'
import * as c from '../constants/ApprovalRequestConstants'
import { DEFAULT_REQUEST_ERROR } from '../constants/MessageConstants'
import axios, { getServerErrorMessage } from '../utils/axios'
import {
  normalizeNonStockedApprovalRequests,
  normalizeAncillaryMaterialsApprovalRequests,
  normalizeExceptionTestingApprovalRequests,
  normalizeOrdersAfterDeadlineApprovalRequests,
  normalizeReshipmentsApprovalRequests,
  normalizeOffCycleTestingApprovalRequests,
} from '../utils/normalize'

export const fetchApprovalRequests = (arType, epc) => (dispatch, getState) => {
  const educationPeriodCd = epc ?? getState().settingsEducationPeriod.current
  const requestUrl = c.APPROVAL_REQUEST_CONFIG[arType].requestsEndpoint.replace(
    '{educationPeriodCd}',
    educationPeriodCd
  )

  dispatch({ type: c.FETCH_APPROVAL_REQUESTS_PENDING })
  return axios
    .get(`${Config.API_URL}${requestUrl}`)
    .then(res => {
      let normalizedData = {}
      switch (arType) {
        case c.ARTYPE_NONSTOCKEDSSD:
          normalizedData = normalizeNonStockedApprovalRequests(res.data)
          break
        case c.ARTYPE_ANCILLARYMATERIALS:
          const normalizedSecureMaterials = normalizeAncillaryMaterialsApprovalRequests(
            res.data.secureMaterials
          )
          const normalizedNonSecureMaterials = normalizeAncillaryMaterialsApprovalRequests(
            res.data.nonSecureMaterials
          )
          normalizedData = {
            entities: {
              approvalRequests: {
                ...normalizedSecureMaterials?.entities?.approvalRequests,
                ...normalizedNonSecureMaterials?.entities?.approvalRequests,
              },
            },
            result: [...normalizedSecureMaterials?.result, ...normalizedNonSecureMaterials?.result],
          }
          break
        case c.ARTYPE_EXCEPTIONTESTING:
          normalizedData = normalizeExceptionTestingApprovalRequests(res.data)
          break
        case c.ARTYPE_ORDERSAFTERDEADLINE:
          normalizedData = normalizeOrdersAfterDeadlineApprovalRequests(res.data)
          break
        case c.ARTYPE_RESHIPMENTS:
          normalizedData = normalizeReshipmentsApprovalRequests(res.data)
          break
        case c.ARTYPE_OFFCYCLETESTING:
          normalizedData = normalizeOffCycleTestingApprovalRequests(res.data)
          break
      }
      dispatch({
        type: c.FETCH_APPROVAL_REQUESTS_FULFILLED,
        payload: { data: normalizedData, arType },
      })
    })
    .catch(err =>
      dispatch({
        type: c.FETCH_APPROVAL_REQUESTS_REJECTED,
        payload: getServerErrorMessage(err || DEFAULT_REQUEST_ERROR),
      })
    )
}

export const fetchApprovalRequestDetail = (id, arType) => (dispatch, getState) => {
  const requestUrl = c.APPROVAL_REQUEST_CONFIG[arType].detailsEndpoint.replace('{id}', id)
  dispatch({ type: c.FETCH_APPROVAL_REQUEST_DETAIL_PENDING, payload: { id } })
  return axios
    .get(`${Config.API_URL}${requestUrl}`)
    .then(res =>
      dispatch({ type: c.FETCH_APPROVAL_REQUEST_DETAIL_FULFILLED, payload: { id, data: res.data } })
    )
    .catch(err =>
      dispatch({
        type: c.FETCH_APPROVAL_REQUEST_DETAIL_REJECTED,
        payload: { id, error: getServerErrorMessage(err || DEFAULT_REQUEST_ERROR) },
      })
    )
}

export const submitApprovalRequest = (status, arType, data) => async dispatch => {
  const config = {
    method: 'post',
    url: '',
    data,
  }
  switch (status) {
    case c.STATUS_APPROVED:
      config.url = `${Config.API_URL}${c.APPROVAL_REQUEST_CONFIG[arType].approvedEndpoint}`
      break

    case c.STATUS_NEEDS_INFO:
      config.url = `${Config.API_URL}${c.APPROVAL_REQUEST_CONFIG[arType].needsInfoEndpoint}`
      break

    case c.STATUS_DENIED:
      config.url = `${Config.API_URL}${c.APPROVAL_REQUEST_CONFIG[arType].deniedEndpoint}`
      break
  }
  try {
    dispatch({ type: c.SUBMIT_APPROVAL_REQUEST_PENDING })
    const res = await axios.request(config)
    dispatch({
      type: c.SUBMIT_APPROVAL_REQUEST_FULFILLED,
      payload: {
        id: data[c.APPROVAL_REQUEST_CONFIG[arType].idField],
        etsApprovalStatus: status,
        comments: data.comments,
        approvalHistory: res.data,
      },
    })
  } catch (err) {
    const errMsg = getServerErrorMessage(err)
    dispatch({ type: c.SUBMIT_APPROVAL_REQUEST_REJECTED, payload: errMsg })
    throw new SubmissionError({ _error: errMsg })
  }
}

export const updateSelectedApprovalRequest = id => dispatch =>
  dispatch({ type: c.UPDATE_SELECTED_APPROVAL_REQUEST, payload: id })
export const clearSelectedApprovalRequest = () => dispatch =>
  dispatch({ type: c.CLEAR_SELECTED_APPROVAL_REQUEST })
export const startProcessingApprovalRequest = () => dispatch =>
  dispatch({ type: c.START_PROCESSING_APPROVAL_REQUEST })
export const stopProcessingApprovalRequest = () => dispatch =>
  dispatch({ type: c.STOP_PROCESSING_APPROVAL_REQUEST })
export const resetProcessingApprovalRequest = () => dispatch =>
  dispatch({ type: c.RESET_APPROVAL_REQUEST })
